import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import api from '../../lib/api';
import { NOTE_TYPES } from './constants';

export default function NoteModal({ isOpen, onClose, request, onNoteAdded }) {
    const [content, setContent] = useState('');
    const [noteType, setNoteType] = useState('call');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;
        setLoading(true);
        try {
            await api.post(`/internal/demo-requests/${request.id}/notes`, { content, note_type: noteType });
            onNoteAdded();
            setContent('');
            onClose();
            toast.success('Note ajoutée');
        } catch { toast.error('Erreur lors de l\'ajout'); }
        finally { setLoading(false); }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose}>
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
                className="bg-slate-900 rounded-2xl w-full max-w-lg border border-white/10 shadow-2xl" onClick={e => e.stopPropagation()}>
                <div className="p-6 border-b border-white/10">
                    <h3 className="text-lg font-semibold text-white">Ajouter une note</h3>
                    <p className="text-white/60 text-sm">{request?.company_name}</p>
                </div>
                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-white/70 mb-2">Type</label>
                        <div className="flex gap-2 flex-wrap">
                            {NOTE_TYPES.map(type => (
                                <button key={type.value} type="button" onClick={() => setNoteType(type.value)}
                                    className={`px-3 py-2 rounded-lg flex items-center gap-2 text-sm transition-colors ${noteType === type.value ? 'bg-purple-500 text-white' : 'bg-white/5 text-white/70 hover:bg-white/10'}`}>
                                    <type.icon size={16} />{type.label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-white/70 mb-2">Note</label>
                        <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={4}
                            placeholder="Compte-rendu de l'appel, informations importantes..."
                            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:border-purple-500" />
                    </div>
                    <div className="flex gap-3 justify-end">
                        <Button type="button" onClick={onClose} variant="outline" className="border-white/20 text-white">Annuler</Button>
                        <Button type="submit" disabled={loading || !content.trim()} className="bg-purple-500 hover:bg-purple-600">{loading ? 'Envoi...' : 'Ajouter'}</Button>
                    </div>
                </form>
            </motion.div>
        </div>
    );
}
